// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3byD7","author":"Table_author__18nko","authorImage":"Table_authorImage__2jh7J","unreadRow":"Table_unreadRow__1BtaR"};